import { NgModule } from '@angular/core';
import { AccountService } from './account/account.services';
import { CategoriesService } from './categories/categories.service';
import { ProductsService } from './product/product.services';
import { StoreService } from './store/store.service';
import { CepService } from './util/cep.service';
import { MelhorEnvioService } from './util/melhor.envio.service';
import { CheckoutService } from './cart/checkout.service';
import { ScriptService } from './util/script.service';
import { OrderService } from './store/order.service';
import { LetterOfCreditService } from './letter-of-credit/letter-of-credit.service';
import { FileService } from './util/file.service';
import { ErrorHandlerService } from './util/error.handler.service';
import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { OnkeypressService } from './util/onkeypress.service';
import { FeaturesStatusService } from './util/features-status.service';
import { ConfigReaderService } from './util/config.reader.service';
import { TranslatableParametersService } from './util/translatable.parameters.service';
import { TokensService } from './tokens/token.service';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { PaginatorTranslationService } from './util/paginator-translation.service';
import { PricesService } from './prices/prices.service';

@NgModule({
    providers: [
        AccountService,
        ProductsService,
        CategoriesService,
        OrderService,
        StoreService,
        ErrorHandlerService,
        ProductsService,
        FileService,
        TokensService,
        MelhorEnvioService,
        TranslatableParametersService,
        ScriptService,
        CheckoutService,
        CepService,
        LetterOfCreditService,
        CurrencyPipe,
        DecimalPipe,
        PricesService,
        OnkeypressService,
        FeaturesStatusService,
        ConfigReaderService,
        {
            provide: MatPaginatorIntl,
            useClass: PaginatorTranslationService
        }
    ]
})
export class ServicesModule { }
